// extracted by mini-css-extract-plugin
module.exports = {"block":"Menu_block__61CrV","backDrop":"Menu_backDrop__3fHkO"};